import { RouteObject } from "react-router-dom";
import ProtectedOutlet from "components/ProtectedOutlet";
import { ClaimResource } from "types/claimTypes";

import UserList from "pages/UserListPage/UserList";
import UserDetails from "pages/UserListPage/UserDetails";
import UserCreateForm from "pages/UserListPage/UserCreateForm";
import UserUpdateForm from "pages/UserListPage/UserUpdateForm";
import UserConfirmMerge from "pages/UserListPage/UserConfirmMerge";
import UserCoursePage from "pages/UserListPage/Tools/UserCoursePage";
import UserCertificatesPage from "pages/UserListPage/Tools/UserCertificatesPage";
import UserSubmissionsPage from "pages/UserListPage/Tools/UserSubmissionsPage";
import UserDesignationsChangeLog from "pages/UserListPage/Tools/UserDesignationsChangeLog";
import UserProfileManagementPage from "pages/UserListPage/Tools/UserProfileManagement";
import ExamResultsPage from "pages/ExamResultsPage";
import ExamAttemptDetails from "pages/ExamResultsPage/ExamAttemptDetails";
import CertifyCourse from "pages/CertifyCoursePage";
import MarkUserAsAttendedPage from "pages/MarkUserAsAttendedPage";
import ModifyEnrollment from "pages/ModifyEnrollmentPage";
import DeleteUserSkuPage from "pages/DeleteUserSkuPage";
import UserChargebackPage from "pages/UserChargebackPage";
import ChangeParentUserSku from "pages/ChangeParentUserSkuPage";

import BulkEnrollmentPage from "pages/BulkEnrollmentPage";
import ManualGradingExamsList from "pages/GradeUserExamsPage/ManualGradingExamsList";
import ManualGradingExamDetails from "pages/GradeUserExamsPage/ManualGradingExamDetails";
import ImpersonateRedirectPage from "pages/ImpersonateRedirectPage";
import UserCertificateDeepLink from "DeepLinks/UserCertificateDeepLink";
import UserCourseDeepLink from "DeepLinks/UserCourseDeepLink";

import UsersPage from "pages/UsersPage";

export const usersRoutes: RouteObject[] = [
  {
    element: <ProtectedOutlet claims={[ClaimResource.Users]} />,
    children: [
      { path: "list", element: <UserList /> },
      { path: "list/new", element: <UserCreateForm /> },
      { path: "list/edit/:id", element: <UserUpdateForm /> },
      { path: "list/-/:id", element: <UserDetails /> },
      { path: "list/:idFrom/merge", element: <UserList /> },
      { path: "list/:idFrom/merge/:idTo", element: <UserConfirmMerge /> },
      { path: "list/:userId/user-course/:userSkuId", element: <UserCoursePage /> },
      { path: "list/:userId/user-course/:userSkuId/tools/exam-results", element: <ExamResultsPage /> },
      { path: "list/:userId/user-course/:userSkuId/tools/exam-results/:examAttemptId", element: <ExamAttemptDetails /> },
      { path: "list/:userId/user-course/:userSkuId/tools/certify", element: <CertifyCourse /> },
      { path: "list/:userId/user-course/:userSkuId/tools/mark-user-as-attended", element: <MarkUserAsAttendedPage /> },
      { path: "list/:userId/user-course/:userSkuId/tools/chargeback", element: <UserChargebackPage /> },
      { path: "list/:userId/user-course/:userSkuId/tools/enrollment", element: <ModifyEnrollment /> },
      { path: "list/:userId/user-course/:userSkuId/tools/delete-user-sku", element: <DeleteUserSkuPage /> },
      { path: "list/:userId/user-course/:userSkuId/tools/certificates", element: <UserCertificatesPage /> },
      { path: "list/:userId/user-course/:userSkuId/tools/change-parent", element: <ChangeParentUserSku /> },
      { path: "list/:userId/tools/certificates", element: <UserCertificatesPage /> },
      { path: "list/:userId/tools/submissions", element: <UserSubmissionsPage /> },
      { path: "list/:userId/tools/user-designations-change-log", element: <UserDesignationsChangeLog /> },
      { path: "list/:userId/tools/profile-management", element: <UserProfileManagementPage /> },
      { path: "bulk-enrollment", element: <BulkEnrollmentPage /> },
      { path: "impersonate/:userId", element: <ImpersonateRedirectPage /> },
      { path: "user-certificates/:userCertificateId", element: <UserCertificateDeepLink /> },
      { path: "user-courses/:userSkuId", element: <UserCourseDeepLink /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.GradeUserExams]} />,
    children: [
      { path: "grade-exams", element: <ManualGradingExamsList /> },
      { path: "grade-exams/-/:id", element: <ManualGradingExamDetails /> },
    ],
  },
  { index: true, element: <UsersPage /> },
];
